import React from 'react';

export const BCAsideItem = ({
  onClick,
  isSelected,
  logo,
  label,
  id,
  isMinimized,
}) => (
  <button className="BCAsideItem" onClick={() => onClick(id)}>
    <i
      className={`BCAsideItem__icon__${
        logo + (isSelected ? '-active' : '')
      } BCAsideItem__icon`}
    />
    <p
      className={`BCAsideItem__name ${
        isMinimized && 'BCAsideItem__name__minimized'
      }`}
    >
      {label}
    </p>
  </button>
);
